import { SharedService } from './../../../../../services/sharedService';
import { ReportViewerPopupComponent } from './../../../../../shared/components/viewer/popup.component';
import { PageState } from './../../../../../shared/enums/stock-files.enum';
import { ReportDesignerComponent } from './../../../reports/report/designer/reportdesigner.component';
import { ElementRef, ɵgetHostElement, ChangeDetectionStrategy } from '@angular/core';
import { Component, Inject, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent, MultiSelectComponent } from '@progress/kendo-angular-dropdowns';
import { AccountsService } from '~/services/administration.ts/accounts';
import { FormatService } from '~/services/administration.ts/format';
import { ReportsService } from '~/services/modules/reports/reports';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { ThemeManagerService } from '~/services/theme-manager';
import { LayoutManagerService, PORTAL_DATA } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { ActivatedRoute } from '@angular/router';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';

@Component({
    selector: 'app-barcode-catalogs-upsert',
    templateUrl: './upsert.html',
    styleUrls: ['./upsert.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BarcodeCatalogsUpsertComponent
  extends MultiSiteAwareComponent
  implements OnDestroy {

  _theme: string;
  _datePickerFormat: string;
  _costFormat: string;
  _active: boolean = true;
  _toggle: boolean = true;
  previewReport: boolean = false;
  categories: any[];
  fields: any;
  selectedFields: any = [];
  mainFieldsList: any;
  _selectedColumns: any[] = [];
  _selectedGroupHeaders: any[] = [];
  previewReportObj: any;
  _action: any;
  definitionOnly: boolean = false;
  currentStep = 0;
  _invalidForm: boolean;
  _currentForm: FormGroup;
  _ispreview: boolean = false;
  _model: any = {
    BarcodeValues: [],
    LabelSizeID: 0,
    Row: 0,
    Column: 0,
    LabelPresetId: 0,
    LabelSize: {},
    numberOfCopy: 1,
    name: ""
  };
  public LogoData: Array<string> = ['Yes', 'No'];
  public AddressData: Array<string> = ['Yes', 'No'];
  public OrientationData: Array<string> = ['Portrait', 'Landscape'];

  @ViewChild('kendo_multiselect') kendoMultiselect: MultiSelectComponent;
  @ViewChild('kendo_multiselect_wrapper') kendoMultiselectWrapper: ElementRef;
  @ViewChild('kendo_combo_Report_Category') kendoComboGroupName: ComboBoxComponent;
  @ViewChild('kendo_input_Report_Name') kendoinputReportName: ElementRef;
  @ViewChild('kendo_combo_groupby') kendoComboGroupBy: ComboBoxComponent;
  @ViewChild('kendo_Combo_Include_Logo') kendoComboIncludeLogo: ComboBoxComponent;
  @ViewChild('kendo_Combo_Include_Address') kendoComboIncludeAddress: ComboBoxComponent;
  @ViewChild('kendo_Combo_Orientation') kendoComboOrientation: ComboBoxComponent;

  editForm: FormGroup;

  _steps = [
    { label: 'Report Info' },
    { label: 'Test Info', optional: true },
    { label: 'Select Fields', disabled: true },
    { label: 'Select Groups', optional: true, disabled: true },
    { label: 'Preview', optional: true }
  ];

  accessFrom: string;
  isAsset: boolean = false;
  filterAssetCatalogCategories: string[] = ["asset-inventory", 'locations', 'persons', 'asset-models', 'asset-models-2', 'conditions']
  excludedStockCatalogCategories: string[] = ['receiveHistory', 'purchaseOrders', 'salesOrders', 'salesOrderToPickList', 'disposeHistory', 'stock-receive-history-enterprise']
  _currentUser: UserSummary;
  //#region Multi Site Variables

  //#endregion
  //#region  CTOR
  constructor(private route: ActivatedRoute,
    private _themeManager: ThemeManagerService,
    private _layoutManager: LayoutManagerService,
    private _accountService: AccountsService,
    private formBuilder: FormBuilder,
    private _reportService: ReportsService,
    private _layoutComponent: LayoutComponent,
    private _gridFields: GridFieldsService,
    private _formatService: FormatService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _multiSitesService: MultiSiteService,
    @Inject(PORTAL_DATA) public data: any) {
    super();
    this.editForm = this.formBuilder.group({
      reportName: new FormControl(null, Validators.required),
      reportCategory: new FormControl(null, Validators.required),
      addAddress: new FormControl(null),
      addLogo: new FormControl(null),
      groupBy: new FormControl(null),
      groupHeader: new FormControl(null),
      orientation: new FormControl(null),
      selectedFields: new FormControl(null, Validators.required)
    });

    this._currentUser = this._securityService.currentUser;

    if (this.route.firstChild) {
      this.route.firstChild.data.subscribe(data => {
        this.accessFrom = data.accessFrom;
        this.isAsset = this.accessFrom === 'assets' ? true : false;
      });
    }
    else {
      this.accessFrom = 'stocks';
      this.isAsset = false;
    }

    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this._layoutManager.applyOverly();

    this.editForm.valueChanges.subscribe((x) => {
      this._currentForm = this.getFormByStep(this.currentStep);
      this.validateSteps();
    });
    this._loadSitesAndInitDD();
  }
  //#endregion
  //#region Multi Site Dropdown Functions
  // sitesChanged(event: any)
  // {
  //   this._siteSelected = event;
  //   this.preview();

  // }
  //#region Multi Site Functions
  _loadSitesAndInitDD(IsEdit: boolean = false, SavedSite: any = null) {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;

      this.initAllSitesDropDown(IsEdit, SavedSite);

    });
  }
  initAllSitesDropDown(isEdit: boolean = false, SavedSite: any = null) {
    super.initAllSitesDropDown(isEdit, SavedSite);
  }
  _handleSitesChange(event: any) {
    super._handleSitesChange(event);
    if (this.selectedFields && this.selectedFields.length > 0)
      this.preview();
  }

  //#endregion
  //#endregion
  //#endregion
  //#region _ReportNameChange
  _ReportNameChange() {
    setTimeout(() => {
      this.kendoComboGroupName.toggle(true);
      this.kendoComboGroupName.focus();
    });
    if (this.selectedFields.length) {
      this.preview();
    }

  }
  //#endregion

  //#region  _closeForm
  _closeForm() {
    this._active = false;
    // this.ngOnDestroy();
    this._layoutManager.removeOverlay();
    var closeComponent = {
      component: 'barcodeCatalog',
      isClosed: true
    }

    this._active = false;
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    // this.kendoMultiselect.toggle(this._toggle);
  }
  //#endregion

  //#region  _onStateChanges
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }
  //#endregion

  //#region _checkForm
  _checkForm(e: any) {
    if (this._toggle) this._onStateChanges(e);
    if (!this._toggle) this._closeForm();
    // (close)="_closeForm()"  (stateChange)="_onStateChanges($event)"
    this._toggle = !this._toggle
  }
  //#endregion

  //#region  toggleSelection
  public toggleSelection(index: number, listNumber: number) {
    let list = listNumber === 0 ? this.fields : this.selectedFields;
    if (list[index].isSelected != undefined)
      list[index].isSelected = !list[index].isSelected;
    else
      list[index].isSelected = true;
  }
  //#endregion
  selectedFieldsWithoutBarcodeImage: any = [];
  _onchangeSelectedFields(event: any) {
    this.selectedFields = event;
    this.selectedFieldsWithoutBarcodeImage = this.selectedFields.filter((x: any) => !x.title.includes("(barcode image)"))
    this.preview();
  }
  //#region  moveSelected
  public moveSelected(direction: any) {
    if (direction === 'left') {
      this.selectedFields.forEach((item: any) => {
        if (item.isSelected) {
          this.fields.push(item);
          var gpheader = [];
          gpheader = this.editForm.controls.groupHeader.value;
          if (gpheader) {
            gpheader.splice(gpheader.findIndex((x: any) => x.id == item.id), 1);
            this.editForm.controls.groupHeader.setValue(gpheader);
          }

          this._selectedColumns.splice(this._selectedColumns.findIndex(x => x.id == item.id), 1);
        }
      });
      this.selectedFields = this.selectedFields.filter((i: any) => !i.isSelected);
    } else {
      this.fields.forEach((item: any) => {
        if (item.isSelected) {
          this.selectedFields.push(item);
        }
      });
      this.fields = this.fields.filter((i: any) => !i.isSelected);
    }
    this._currentForm = this.getFormByStep(this.currentStep);
    this.validateSteps();

    this.editForm.patchValue({
      selectedFields: this.selectedFields
    });

    if (this.kendoComboGroupBy.value) {
      var itemIndex = this.selectedFields.findIndex((c: any) => c.field === this.kendoComboGroupBy.value.field);
      if (itemIndex == -1) {
        this.kendoComboGroupBy.value = null;
      }
    }
    this.preview();
  }
  //#region

  //#region  verticalMove
  public verticalMove(direction: any) {
    var index = -1;
    var newIndex = -1;

    var currentSelectedField = this.selectedFields.filter((i: any) => i.isSelected);
    var firstItemIndex = this.selectedFields.findIndex((x: any) => x.field === currentSelectedField[0].field);
    var lastItemIndex = this.selectedFields.findIndex((x: any) => x.field === currentSelectedField[currentSelectedField.length - 1].field);

    if (direction === 'up' && firstItemIndex > 0) {
      currentSelectedField.forEach((item: any) => {

        index = this.selectedFields.findIndex((x: any) => x.field === item.field);
        newIndex = index - 1;

        this.selectedFields = this.selectedFields.filter((i: any) => i.title != "");
        if (newIndex < (this.selectedFields.length - 1) || newIndex > 0) {
          this.selectedFields.splice(newIndex, 0, this.selectedFields.splice(index, 1)[0]);
        }

      });
    }
    else if (direction === 'down' && lastItemIndex < this.selectedFields.length - 1) {
      for (let i = currentSelectedField.length - 1; i >= 0; i--) {

        index = this.selectedFields.findIndex((x: any) => x.field === currentSelectedField[i].field);
        newIndex = index + 1;

        this.selectedFields = this.selectedFields.filter((x: any) => x.title != "");
        if (newIndex < (this.selectedFields.length - 1) || newIndex > 0) {
          this.selectedFields.splice(newIndex, 0, this.selectedFields.splice(index, 1)[0]);
        }

      }
    }
    this.validateSteps();
  }
  //#endregion

  //#region moveAll
  public moveAll(direction: any) {
    if (direction === 'left') {
      this.fields = [...this.fields, ...this.selectedFields];
      this.selectedFields = [];
      this._selectedColumns = [];
      this.editForm.controls.groupHeader.setValue([]);
    } else {
      this.selectedFields = [...this.selectedFields, ...this.fields];
      this.fields = [];
    }
    this._currentForm = this.getFormByStep(this.currentStep);
    this.validateSteps();
    this._updateSelectedFieldsForGrouping();
    this.preview();
  }
  //#endregion

  //#region _updateSelectedFieldsForGrouping
  _updateSelectedFieldsForGrouping() {
    this.editForm.patchValue({
      selectedFields: this.selectedFields
    });

    if (this.kendoComboGroupBy.value) {
      var itemIndex = this.selectedFields.findIndex((c: any) => c.field === this.kendoComboGroupBy.value.field);
      if (itemIndex == -1) {
        this.kendoComboGroupBy.value = null;
      }
    }
  }
  //#endregion
  //#region GetFieldsByCategory
  GetFieldsByCategory(category: any) {
    this._model.LabelPresetId = category.id;
    this.selectedFields = [];
    this._gridFields.getGridFieldsByPage(category.reportCategorycode, true).subscribe(
      (x: any) => {

        //this.fields = x;
        this.fields = this._addBarcodeImageGridField(x);
        this.mainFieldsList = x;
        this.selectedFields = [];
        this.currentStep = 1;

        // this.preview();
        if (this.selectedFields.length) {
          this.preview();
        }
        if (this.editForm.get('addLogo').value == null) {
          setTimeout(() => {
            this.kendoComboIncludeLogo.toggle(true);
            this.kendoComboIncludeLogo.focus();
          });
        }
      }
    );
  }
  //#endregion
  //#region getLogoChange
  getLogoChange() {
    if (this.selectedFields.length) {
      this.preview();
    }
    setTimeout(() => {
      this.kendoComboIncludeAddress.toggle(true);
      this.kendoComboIncludeAddress.focus();
    });
  }
  //#endregion

  //#region includeAddressChange
  includeAddressChange() {
    if (this.selectedFields.length) {
      this.preview();
    }
    setTimeout(() => {
      this.kendoComboOrientation.toggle(true);
      this.kendoComboOrientation.focus();
    });
  }
  //#endregion

  //#region orientationChange
  orientationChange() {
    if (this.selectedFields.length) {
      this.preview();
    }
    this.currentStep = 2;
  }
  //#endregion

  //#region _itemDisabled
  _itemDisabled(itemArgs: { dataItem: any; index: number }): boolean {
    return itemArgs.dataItem.$disabled;
  }
  //#endregion

  //#region _getReportCategories
  _getReportCategories() {
    return this._reportService.AllCategories(this.isAsset).subscribe(
      (x: any) => {
        this.categories = x.filter((x: any) => x.dataSource != null);
        if (this.isAsset)
          this.categories = this.categories.filter(x => this.filterAssetCatalogCategories.includes(x.reportCategorycode));
        else
          this.categories = this.categories.filter(x => !this.excludedStockCatalogCategories.includes(x.reportCategorycode));

        this.categories = this.categories.map((category) => {
          if (category.reportCategorycode === 'asset-inventory') {
            category.reportCategoryname = 'Asset';
          }
          return category;
        });
      }
    );
  }
  //#endregion

  //#region _groupHeaderSelected
  _groupHeaderSelected(e: any) {
    this.selectedFields.forEach((column: any) => {
      column.gpSelected = e.find((x: any) => x.id == column.id) != null;
    });
  }
  //#endregion

  //#region _isItemSelected
  _isItemSelected(id: any) {
    return this._selectedGroupHeaders.some(item => item.id === id);
  }
  //#endregion

  //#region  preview
  preview() {
    // this.currentStep = 4;
    this.previewReport = true;
    var x = {
      ReportObj: this.getReportObject(),
      selectedFields: this.selectedFields
    };
    this.previewReportObj = x;
    this._ispreview = true;
  }
  //#endregion

  //#region save
  save(action: any) {
    this.definitionOnly = true;
    var x = {
      ReportObj: this.getReportObject(),
      selectedFields: this.selectedFields
    };
    this.previewReportObj = x;
    this.previewReport = true;
    this._action = action;
  }
  //#endregion

  //#region saveReportDefinition
  saveReportDefinition(definition: any) {
    this.previewReportObj.ReportObj.definition = definition;
    this.previewReportObj.ReportObj.isCatalog = true;
    this._reportService.saveNewReport(this.previewReportObj.ReportObj)

      .subscribe(
        (x: any) => {
          if (this._action == 'close') {
            this._reportService.refreshReports("-1");
            this._closeForm();

          }
          else if (this._action == 'edit') {
            this._reportService.refreshReports(x, true);
            this._closeForm();
            this.openDesigner(x);


          }
          else {
            this._reportService.refreshReports(x);
            this._closeForm();
            this.openViewer(x);


          }
        }
      );
  }
  //#endregion
  //#region _addBarcodeImageGridField
  _addBarcodeImageGridField(gridFieldList: any[]) {
    for (let i = 0; i <= gridFieldList.length; i++) {
      let imageField = Object.assign('', gridFieldList[i]);
      // imageField.field += "(barcode image)";
      imageField.title += " (barcode image)";
      gridFieldList.splice(i + 1, 0, imageField);
      i++;
    }
    return gridFieldList;
  }
  //#endregion
  //#region getReportObject
  getReportObject() {
    this._model.name = this.editForm.controls["reportName"].value;
    return {
      name: this.editForm.controls["reportName"].value,
      isForecast: 0,
      systemReport: 0,
      isCatalog: 1,
      isAsset: this.isAsset,
      siteId: this._siteSelected?.id > 0 ? this._siteSelected.id : null,
      pageName: this.editForm.controls["reportCategory"].value ? this.editForm.controls["reportCategory"].value.reportCategorycode : null,
      reportCategoryId: this.editForm.controls["reportCategory"].value ? this.editForm.controls["reportCategory"].value.reportCategoryid : null,
      dataSource: this.editForm.controls["reportCategory"].value ? this.editForm.controls["reportCategory"].value.dataSource : null,
      addAddress: this.editForm.controls["addAddress"].value,
      addLogo: this.editForm.controls["addLogo"].value,
      groupBy: this.editForm.controls["groupBy"].value ? this.editForm.controls["groupBy"].value.field : null,
      header: this.editForm.controls["groupHeader"].value ?
        Array.prototype.map.call(this.editForm.controls["groupHeader"].value, function (item: any) { return item.field; }).join(",") : null,
      orientation: this.editForm.controls["orientation"].value,
      selectedFields: Array.prototype.map.call(this.selectedFields, function (item: any) { return item.field; }).join(","),
      definition: ''
    };
  }
  //#endregion
  //#region validateSteps
  private validateSteps() {
    this._steps.forEach((x, index) => {
      x['disabled'] = !this._canGoToStep(index);
      this._currentForm = this.getFormByStep(this.currentStep);
    });
  }
  //#endregion

  //#region previousStep
  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep -= 1;
    }
  }
  //#endregion
  nextStep() {
    if (!this._steps[this.currentStep + 1]['disabled']) {
      if (this.currentStep < this._steps.length - 1) {
        this.currentStep += 1;
      }
      this._invalidForm = false;
    } else {
      this._currentForm = this.getFormByStep(this.currentStep);
      if (this._currentForm && this._canGoToStep(this.currentStep + 1)) {
        this.currentStep += 1;
      }
      this._invalidForm = true;
    }

    this.preview();
  }

  _skipStep() {
    this.currentStep += 1;
  }

  _skipStepOrientation() {
    if (this.editForm.get('orientation').value == null) {
      this.editForm.patchValue({
        orientation: 'Portrait'
      });
    }
    this.currentStep += 1;
    if (this.selectedFields.length) {
      this.preview();
    }
    //this.preview();
  }

  private getFormByStep(step: number) {
    switch (step) {
      case 0:
        return this.formBuilder.group({
          reportName: new FormControl(this.editForm.get('reportName').value, Validators.required),
          reportCategory: new FormControl(this.editForm.get('reportCategory').value, Validators.required),
        });
      case 1:
        return this.formBuilder.group({
          reportName: new FormControl(this.editForm.get('reportName').value, Validators.required),
          reportCategory: new FormControl(this.editForm.get('reportCategory').value, Validators.required)
        });
    }
  }

  _canGoToStep(step: number) {
    switch (step) {
      case 0:
        return true;
      case 1:
        if ((this.editForm.get('reportName').value) && (this.editForm.get('reportCategory').value)) {
          return true;
        } else {
          return false;
        }
      case 2:
        return true;
      case 3:
        if ((this.selectedFields) && (this.selectedFields.length > 0)) {
          return true;
        }
        else {
          return false;
        }
      case 4:
        return true;
    }
  }

  selectGroupHeader(object: any) {
    if (object) {
      var x = [];
      if (this.editForm.controls.groupHeader.value) {
        x = this.editForm.controls.groupHeader.value;
        if (!x.find((y: any) => y.id == object.id)) {
          object.gpSelected = true;
          x.push(object);
          this.editForm.controls.groupHeader.setValue(x);
        }
      }
      else {
        object.gpSelected = true;
        x.push(object);
        this.editForm.controls.groupHeader.setValue(x);
      };
      if (!this._selectedColumns.find((x: any) => x.id == object.id))
        this._selectedColumns.push(object);
    }
    this.editForm.controls.groupBy.setValue(object);
    //this.preview();
    if (this.selectedFields.length) {
      this.preview();
    }
    this.kendoMultiselect.toggle(true);
  }
  //#region ngOnDestroy
  ngOnDestroy() {

  }
  //#endregion

  //#region _groupheaderChange
  _groupheaderChange(e: any) {
    this.selectedFields.forEach((column: any) => {
      column.gpSelected = e.find((x: any) => x.id == column.id) != null;
    });
    this.preview();
  }
  //#endregion
  //#region  _multiSelectClose
  _multiSelectClose(e: any) {
    if (!ɵgetHostElement(this.kendoMultiselect).contains(e.target)) {
      this.kendoMultiselect.toggle(false);
      this._toggle = !this._toggle;
    }
  }
  //#endregion

  //#region ngOnInit
  ngOnInit(): void {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    if (loggedInAccountSites != "") {
      var site = JSON.parse(loggedInAccountSites)[0];

      this._siteSelected = { id: site.siteId, name: site.code, description: "" };
    }
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this._getReportCategories();
    setTimeout(() => {
      this.kendoinputReportName.nativeElement.focus();
    });
  }
  //#endregion
  openDesigner(reportid: number) {
    this._layoutComponent.openDialogForm(ReportDesignerComponent, PageState.EDIT, { reportId: reportid });
  }
  openViewer(reportid: number) {

    this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.EDIT, { reportId: reportid, });
  }
}
